import type { FC} from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageCode } from '../../../../../../store/app/appStore';
import { testIds } from '../../../../../../core/testIds';

import styles from './TopGameBanner.module.css';

const TopGameBanner: FC = () => {
  const { t } = useTranslation();
    const currentLang = useLanguageCode();

    const isCJK = useMemo(() => ['KO', 'ZH-CN']
      .includes(currentLang), [currentLang]);

  return (
    <div className={styles.badge} data-lang={isCJK ? 'cjk' : 'default'} data-testid={testIds.games.topGameBadge}>
      {t('generic_top', 'top').toUpperCase()}
    </div>
  );
};

export default TopGameBanner;